import React from 'react';
import { EdgeProps } from '@xyflow/react';
import { isNil } from 'lodash';

// -----------------------------------------------------------------------------
interface RelationshipToChildEdgeProps extends EdgeProps {
  data?: {
    stepHeight: number;
    twinGroupCenterX?: number;
  };
}

// -----------------------------------------------------------------------------
const RelationshipToChildEdge: React.FC<RelationshipToChildEdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  style = {},
  data,
  markerEnd,
}) => {
  if (!data?.stepHeight) {
    return null;
  }

  // ---------------------------------------------------------------------------
  const stepY = sourceY + data.stepHeight;
  let pathData = `M ${sourceX},${
    sourceY - 8
  } L ${sourceX},${stepY} L ${targetX},${stepY} L ${targetX},${targetY + 4}`;

  // ---------------------------------------------------------------------------
  if (!isNil(data?.twinGroupCenterX)) {
    const midX = data.twinGroupCenterX;
    pathData = `M ${sourceX},${
      sourceY - 8
    } L ${sourceX},${stepY} L ${midX},${stepY}
    L ${midX},${stepY + 8}
    L ${targetX},${targetY + 4}`;
  }

  // ---------------------------------------------------------------------------
  return (
    <path
      id={id}
      style={style}
      className="react-flow__edge-path"
      d={pathData}
      markerEnd={markerEnd}
    />
  );
};

export default RelationshipToChildEdge;
